import React, { useEffect, useRef } from 'react';
import { pitchText } from '../data/content';
import Reveal from './Reveal';
import TopoBackground from './TopoBackground';
import './Pitch.css';

/**
 * Krátky textový pitch hneď pod hero sekciou.
 * Pozadie (vrstevnice) sleduje kurzor myši (parallax naklonenie).
 * Bez kurzora (mobil/tablet) sa namiesto toho pomaly samo posúva.
 * Pri prefers-reduced-motion ostáva úplne statické.
 */
export default function Pitch() {
  const sectionRef = useRef(null);
  const bgRef = useRef(null);

  useEffect(() => {
    const section = sectionRef.current;
    const bg = bgRef.current;
    if (!section || !bg) return undefined;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return undefined;
    }

    const canFollowCursor = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (canFollowCursor) {
      const handleMove = (event) => {
        const rect = section.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        bg.style.setProperty('--tilt-x', x.toFixed(3));
        bg.style.setProperty('--tilt-y', y.toFixed(3));
      };
      const handleLeave = () => {
        bg.style.setProperty('--tilt-x', 0);
        bg.style.setProperty('--tilt-y', 0);
      };
      section.addEventListener('mousemove', handleMove);
      section.addEventListener('mouseleave', handleLeave);
      return () => {
        section.removeEventListener('mousemove', handleMove);
        section.removeEventListener('mouseleave', handleLeave);
      };
    }

    // Dotykové zariadenie bez kurzora – jemný, pomalý automatický posun.
    bg.classList.add('pitch__bg--drift');
    return undefined;
  }, []);

  return (
    <section className="section section--gray pitch" id="preco" ref={sectionRef}>
      <div className="pitch__bg" ref={bgRef} aria-hidden="true">
        <TopoBackground />
      </div>

      <div className="container container--narrow pitch__content">
        <Reveal className="section-heading">
          <h2>{pitchText.heading}</h2>
        </Reveal>
        {pitchText.paragraphs.map((paragraph, index) => (
          <Reveal key={paragraph} delay={index * 0.1}>
            <p className="pitch__text">{paragraph}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
